/* eslint-disable @typescript-eslint/naming-convention */
export enum SEARCH_TABS {
  quick_search = 'quick-search',
  advanced_search = 'advanced-search',
}
